var exports = {
  "kL": "xf0b3b88a--14fdb4--container",
  "hP": "xf0b3b88a--14fdb4--slides",
  "X_": "xf0b3b88a--14fdb4--slides--no-transform",
  "M6": "xf0b3b88a--14fdb4--slide",
};

module.exports = exports;
